import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";

export const AboutDialog = ({ open, onOpenChange }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent data-testid="about-dialog" className="max-w-md">
      <DialogHeader>
        <DialogTitle className="font-heading tracking-[0.15em]">KAZO</DialogTitle>
        <DialogDescription>Merchandise Intelligence OS · v1.0</DialogDescription>
      </DialogHeader>
      <div className="text-sm space-y-3 text-slate-600 dark:text-slate-300">
        <p>A live, SKU-level merchandise, inventory and decision platform. Every number on screen is computed by an engine from the normalized data model (Variant SKU × Size × Location × Date).</p>
        <p>Recommendation engines (replenishment, transfer, markdown, priority score) are <strong>rule-based</strong> and clearly labelled; forecasting and conversational Copilot are later phases.</p>
        <p className="pt-2 border-t border-slate-200 dark:border-slate-800" data-testid="about-powered-by">Powered by <span className="font-semibold text-slate-900 dark:text-white">Fundle</span></p>
      </div>
    </DialogContent>
  </Dialog>
);
